import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Send, Hammer, PackageOpen } from 'lucide-react';

export type FlightStatus = 'sent_to_operators' | 'posting_started' | 'removal_started' | null | undefined;

const CONFIG: Record<
  NonNullable<FlightStatus>,
  { label: string; icon: React.ElementType; bg: string; text: string; tooltip: string }
> = {
  sent_to_operators: {
    label: 'Sent',
    icon: Send,
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    tooltip: 'Assignments have been dispatched to operators — no posting events yet.',
  },
  posting_started: {
    label: 'Posting',
    icon: Hammer,
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    tooltip: 'At least one operator has started posting in the field.',
  },
  removal_started: {
    label: 'Removing',
    icon: PackageOpen,
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    tooltip: 'Removal work has started — material is coming off walls.',
  },
};

interface FlightStatusBadgeProps {
  status: FlightStatus;
}

export function FlightStatusBadge({ status }: FlightStatusBadgeProps) {
  if (!status) return null;

  const cfg = CONFIG[status];
  const Icon = cfg.icon;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${cfg.bg} ${cfg.text}`}
          >
            <Icon className="h-3 w-3" />
            {cfg.label}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p className="max-w-[220px] text-xs">{cfg.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
